export const canvasCopy = {
  addNode: "添加节点",
  uploadMedia: "上传素材",
  seedanceNode: "Seedance 生成",
  retrySave: "重试保存",
  back: "返回项目",
  undo: "撤销",
  redo: "重做",
  searchNodes: "搜索画布节点",
  locate: "定位",
  addText: "添加文本",
  textNode: "文本节点",
  assets: "素材",
  inspector: "检查器",
  collapseAssets: "收起素材库",
  expandAssets: "展开素材库",
  collapseInspector: "收起检查器",
  expandInspector: "展开检查器",
  canvasPreview: "画布预览",
  account: "账户",
  canvasHistory: "画布历史记录",
  saved: "已保存",
  saving: "正在保存…",
  offlineDraft: "离线草稿已保存到本地",
  saveFailed: "保存失败，可重试",
  conflict: "发生冲突，请选择处理方式",
  canvasUpgradeRequired: "画布格式已升级，请先导出本地恢复副本，再刷新页面或加载服务器版本；当前本地内容已保留，系统不会自动重试覆盖。",
  draftConversionFailed: "草稿无法安全转换，原草稿已保留。请导出恢复副本或选择其他草稿。",
  loading: "正在加载…",
  loadServer: "加载服务器版本",
  copyLocal: "将本地版本复制为新项目",
  unsavedWarning: "最新修改尚未在服务器或本地得到保存确认，请先导出恢复副本。",
  localStorageWarning: "本地草稿保存失败；服务器保存状态见上方。",
  unsavedLeave: "最新修改尚未保存，离开或切换版本可能丢失内容。建议取消并先导出恢复副本。仍要继续吗？",
  exportLocal: "导出当前画布恢复副本",
  recoveryDrafts: "本地恢复副本",
  refreshDrafts: "查看／刷新恢复副本",
  restoreDraft: "恢复此副本",
  recoveryReadFailed: "暂时无法读取本地恢复副本，请重试。",
  recoveryPartialReadFailed: "个本地恢复副本无法读取，原记录已保留；其他副本仍可恢复。",
  recoveryActionFailed: "操作未完成，本地画布已保留，请重试或导出。",
  touchFailure: "已添加，但无法更新最近使用记录。",
  projectCanvas: "项目画布",
  moveGroup: "移动分组",
  ungroup: "取消分组",
  groupActions: "分组操作",
  viewGroupName: "查看分组完整名称",
  fullName: "完整名称",
  groupFullName: "分组完整名称",
  closeGroupName: "关闭",
  canvasControls: "画布视图控制",
  canvasQuickTools: "画布快捷工具",
  zoomIn: "放大画布",
  zoomOut: "缩小画布",
  fitView: "适应视图",
  centerView: "居中视图",
  selectCanvas: "框选素材",
  panCanvas: "移动画布",
  selectedNodeActions: "已选节点操作",
  openSelectedNodeMenu: "打开已选节点菜单",
  selectedNodeCount: "已选节点数",
  bulkSelectMedia: "批量选素材",
  bulkSelectionHint: "请点选至少两个图片、视频或音频素材",
  bulkSelectedMedia: "已选素材",
  bulkDragHint: "拖动任一右侧端口即可批量连线",
  batchConnectionHint: "从任一发光端口拖动可批量连线。",
  createBulkSeedance: "新建 Seedance 并批量引用",
  selectBulkSeedanceTarget: "选择批量引用目标",
  connectBulkToSeedance: "批量作为参考素材",
  alignLeft: "左对齐",
  alignTop: "顶部对齐",
  distributeHorizontal: "水平等距分布",
  distributeVertical: "垂直等距分布",
  group: "创建分组",
  unfold: "展开节点",
  fold: "折叠节点",
  duplicate: "复制节点",
  delete: "删除节点",
  connectionActions: "连线操作菜单",
  deleteConnection: "删除连线",
  workflowSaved: "工作流已保存",
  workflowInserted: "工作流已插入",
  workflowLoadFailed: "私有工作流加载失败。",
  selectWorkflowNodes: "请先选择要保存的节点。",
  savePrivateWorkflow: "保存为私有工作流",
  insertPrivateWorkflow: "插入私有工作流",
  selectPrivateWorkflow: "选择要插入的私有工作流",
  privateWorkflowList: "可插入的私有工作流",
  canvasGroups: "画布分组",
  uploadQueue: "上传队列",
  uploadQueued: "等待上传",
  uploading: "正在上传",
  uploadProcessing: "正在处理",
  uploadComplete: "上传完成",
  uploadFailed: "素材上传失败。",
  uploadCancelled: "已取消上传",
  uploadItem: "上传项",
  uploadProgress: "上传进度",
  retryUpload: "重试上传",
  cancelUpload: "取消上传",
  dropMedia: "将素材拖放到此处添加",
  selectSeedance: "选择 Seedance 节点以编辑提示词、引用和参数。",
  openingProject: "正在打开项目…",
  projectNotFound: "未找到项目",
  networkUnavailable: "网络不可用",
  projectOpenFailed: "无法打开项目",
  privateAssetLibrary: "私有素材库",
  assetViews: "素材视图",
  searchAssets: "搜索素材",
  assetKind: "素材类型",
  all: "全部",
  images: "图片",
  videos: "视频",
  audio: "音频",
  search: "搜索",
  retry: "重试",
  restore: "恢复",
  trash: "移入回收站",
  loadMore: "加载更多",
  assetsLoadFailed: "素材加载失败。",
  referenceControls: "参考素材控制",
  removeReference: "移除参考素材",
  moveUp: "上移",
  role: "角色",
  mode: "模式",
  order: "顺序",
  requestPreview: "Seedance 请求预览",
  ready: "可提交",
  error: "错误",
  mobileNodeList: "移动端节点列表",
  nodes: "节点",
  emptyNote: "空白笔记",
  emptyScript: "暂无脚本内容",
  manualScript: "手动脚本",
  mediaPreviewOmitted: "为保证性能，未显示素材预览。",
  imageInTrash: "此图片位于回收站，可在素材库中恢复。",
  videoInTrash: "此视频位于回收站，可在素材库中恢复。",
  audioInTrash: "此音频位于回收站，可在素材库中恢复。",
  imageUnavailable: "此图片不可用。请保留节点，并在素材库中重试。",
  videoUnavailable: "此视频不可用。请保留节点，并在素材库中重试。",
  audioUnavailable: "此音频不可用。请保留节点，并在素材库中重试。",
  imageNode: "图片素材",
  videoNode: "视频素材",
  audioNode: "音频素材",
  prompt: "提示词",
  savePromptTemplate: "保存为模板",
  myPromptTemplates: "我的模板",
  closePromptTemplates: "关闭我的模板",
  loadingPromptTemplates: "正在加载我的模板…",
  promptTemplatesLoadFailed: "我的模板加载失败，请重试。",
  noPromptTemplates: "还没有个人提示词模板。",
  insertPromptTemplate: "插入光标位置",
  replacePromptTemplate: "替换当前提示词",
  promptTemplateTitle: "模板名称",
  confirmSavePromptTemplate: "确认保存",
  promptTemplateSaved: "提示词模板已保存。",
  promptTemplateSaveFailed: "提示词模板保存失败，请重试。",
  model: "模型",
  ratio: "画幅",
  duration: "时长",
  resolution: "分辨率",
  seed: "随机种子",
  generateAudio: "生成音频",
  watermark: "添加水印",
  createProject: "创建项目",
  openCanvas: "打开画布"
} as const;

export const referenceRoleCopy = {
  reference: "参考",
  reference_video: "参考视频",
  first_frame: "首帧",
  last_frame: "尾帧",
  subject: "主体",
  scene: "场景",
  style: "风格",
  composition: "构图",
  action: "动作",
  camera: "镜头",
  extend_video: "延展视频",
  audio_reference: "音频参考",
  custom: "自定义"
} as const satisfies Record<ReferenceRole, string>;

export const seedanceModelCopy = {
  "doubao-seedance-2-0-260128": "Seedance 2.0",
  "doubao-seedance-2-0-fast-260128": "Seedance 2.0 Fast"
} as const satisfies Record<SeedanceModel, string>;

export function seedanceModelLabel(model: SeedanceModel): string {
  return seedanceModelCopy[model];
}

export const referenceModeCopy = {
  strict: "严格参考",
  action_only: "仅参考动作",
  camera_only: "仅参考镜头",
  rhythm_only: "仅参考节奏",
  style_only: "仅参考风格",
  custom: "自定义"
} as const satisfies Record<ReferenceMode, string>;

export function referenceRoleLabel(role: ReferenceRole): string {
  return referenceRoleCopy[role];
}

export function referenceModeLabel(mode: ReferenceMode): string {
  return referenceModeCopy[mode];
}

export function assertNoReplacementCharacter(source: string): void {
  if (source.includes("\uFFFD")) throw new Error("UTF-8 文本包含替换字符。");
}
import type { ReferenceMode, ReferenceRole, SeedanceModel } from "@seedance/contracts";
